import { DocumentNode, gql } from '@apollo/client'

export const CREATE_OCCASIONAL_SLOT: DocumentNode = gql`
    mutation createOccasionalSlot($daycare_id: Int!, $occasionalSlots: [newOccasionalSlot]!) {
        createOccasionalSlot(daycare_id: $daycare_id, occasionalSlots: $occasionalSlots)
    }
`

export const UPDATE_OCCASIONAL_SLOT: DocumentNode = gql`
    mutation UpdateOccasionalSlot($daycare_id: Int!, $occasionalSlots: [updateOccasionalSlot]!) {
        updateOccasionalSlot(daycare_id: $daycare_id, occasionalSlots: $occasionalSlots)
    }
`

export const RELEASE_SCHEDULED_OCCASIONAL_SLOT: DocumentNode = gql`
    mutation ReleaseScheduledOccasionalSlots($daycare_id: Int!, $sectionIds: [Int]!, $until: Date) {
        releaseScheduledOccasionalSlots(daycare_id: $daycare_id, sectionIds: $sectionIds, until: $until)
    }
`

export const DELETE_OCCASIONAL_SLOT: DocumentNode = gql`
    mutation DeleteOccasionalSlot($daycare_id: Int!, $occasionalSlots: [Int]!, $daycareComment: String) {
        deleteOccasionalSlot(
            daycare_id: $daycare_id
            occasionalSlots: $occasionalSlots
            daycareComment: $daycareComment
        )
    }
`

export const DUPLICATE_OCCASIONAL_SLOT: DocumentNode = gql`
    mutation DuplicateOccasionalSlot($slotId: Int!, $count: Int!, $daycareId: Int!) {
        duplicateOccasionalSlot(slotId: $slotId, count: $count, daycareId: $daycareId)
    }
`

export const RELEASE_OCCASIONAL_SLOT: DocumentNode = gql`
    mutation ReleaseOccasionalSlot($daycare_id: Int!, $occasionalSlots: [Int]!) {
        releaseOccasionalSlot(daycare_id: $daycare_id, occasionalSlots: $occasionalSlots)
    }
`

export const GET_LAST_OCCASIONAL_SLOT: DocumentNode = gql`
    query getLastOccasionalSlot($parentId: Int, $daycareId: Int!) {
        getLastOccasionalSlot(parentId: $parentId, daycareId: $daycareId) {
            id
            daycareId
            sectionId
            childId
            childName
            childComplement
            parentName
            parentId
            section
            parentComment
            date
            start
            end
            type
            matching
            limit {
                childId
                limit
            }
            scheduled
            expiry
            created
            updated
            externalNote
            externalIcon
            internalNote
            priorityGroup {
                id
                name
            }
            priorityChild {
                id
                firstname
            }
            placeId
            placeName
            placeAddress
        }
    }
`
